import { Component, OnInit, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { IconComponent } from '../../components/icon/icon.component';
import { Message } from '../../domain/messages.domain';
import { EmptyHeaderComponent } from '../../components/datatable/components/empty/empty-header.component';
import { EmptyComponent } from '../../components/datatable/components/empty/empty.component';

import { PagePanelComponent } from '../page/page-panel.component';
import { MessagesComponent } from './messages.component';
interface MessageGroup {
  priorityMessages: {
    importance: Array<string>;
    messages: Array<Message>;
  };
  nonPriorityMessages: {
    messages: Array<Message>;
  };
}

@Component({
  selector: 'td-wb-messages-group',
  templateUrl: './messages-group.component.html',
  styleUrls: ['./messages-group.component.scss'],
  imports: [
    PagePanelComponent,
    MessagesComponent,
    EmptyHeaderComponent,
    EmptyComponent,
    IconComponent,
    TranslateDirective
  ]
})
export class MessagesGroupComponent implements OnInit {
  readonly messages = input<Array<Message>>(undefined);
  readonly priorityOnly = input<boolean>(undefined);
  readonly updateMessagesCounter = input<boolean>(undefined);
  readonly expandMessages = input<boolean>(undefined);
  messageGroup: MessageGroup;
  messageGroupList: Array<string>;

  constructor() {
  }

  ngOnInit(): void {
    this.messageGroup = {
      priorityMessages: {
        importance: ['CRITICAL', 'ESSENTIAL'],
        messages: []
      },
      nonPriorityMessages: {
        messages: []
      }
    };
    this.prioritizeMessages(this.messages());
    this.messageGroupList = Object.keys(this.messageGroup);
  }

  hasGroupWithMessages(): boolean {
    let group;
    for (group in this.messageGroup) {
      if (Object.getOwnPropertyDescriptor(this.messageGroup, group) && this.messageGroup[group].messages.length > 0) {
        return true;
      }
    }
    return false;
  }

  canShowGroup(key: string): boolean {
    if (this.priorityOnly()) {
      return key === 'priorityMessages';
    }
    return this.messageGroup[key].messages.length > 0;
  }

  private prioritizeMessages(messages: Array<Message>): void {
    if (messages !== undefined && messages instanceof Array) {
      messages.forEach((message: Message): void => {
        if (this.messageGroup.priorityMessages.importance.indexOf(message.importance.toUpperCase()) >= 0) {
          this.messageGroup.priorityMessages.messages.push(message);
        } else {
          this.messageGroup.nonPriorityMessages.messages.push(message);
        }
      });
    }
  }
}
